import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62cf310a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Закрыть")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Включить всем")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Выключить всем")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("mdi-arrow-up")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Разрешите использование камеры, выберите Back Camera и нажмите Start Scanning")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Доступы сканировщикам...")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Скачать проходы CSV")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Загрузить")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("УЖЕ ПОГАШЕН")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Запросить доступ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Доступ запрошен, ожидайте. ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.accessDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accessDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accessDialog=false))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleAccessAll(true)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleAccessAll(false)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessUsers, (user, key) => {
              return (_openBlock(), _createBlock(_component_v_checkbox_btn, {
                onClick: ($event: any) => (_ctx.setUserAccess(key, user.access)),
                key: key,
                modelValue: user.access,
                "onUpdate:modelValue": ($event: any) => ((user.access) = $event),
                label: user.email,
                class: "pl-3 py-2"
              }, null, 8, ["onClick", "modelValue", "onUpdate:modelValue", "label"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createVNode(_component_v_card, {
      class: _normalizeClass(_ctx.getColor())
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_sheet, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "reader",
              style: _normalizeStyle(_ctx.renderStyle)
            }, null, 4),
            (_ctx.html5QrcodeScanner && _ctx.html5QrcodeScanner.getState() != 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _hoisted_5,
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.isAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_v_btn, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.accessDialog = true)),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadCSVPasses())),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin() && _ctx.userData?.email=='ceo@ticketcafe.ru')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_v_file_input, {
                modelValue: _ctx.filePath,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filePath) = $event)),
                  _ctx.fileSelect
                ],
                label: "CSV input"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.drop,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.drop) = $event)),
                label: "Заменять"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.isComma,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isComma) = $event)),
                label: "Разделитель , иначе ;"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_btn, { onClick: _ctx.processFile }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_text_field, {
                class: "pt-1 pb-0 px-4 ma-0 centered-input font-weight-bold",
                placeholder: "rdbname",
                modelValue: _ctx.rdbname,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rdbname) = $event)),
                density: "compact",
                "single-line": "",
                variant: "solo-filled",
                active: "",
                clearable: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.addScan,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addScan) = $event)),
                label: "Добавить новые билеты при сканировании"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_text_field, {
          class: "pt-1 pb-0 px-4 ma-0 centered-input font-weight-bold",
          placeholder: "Сканируйте или введите код",
          modelValue: _ctx.scanValue,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.scanValue) = $event)),
          density: "compact",
          onChange: _ctx.onInput,
          "single-line": "",
          variant: "solo-filled",
          active: "",
          clearable: ""
        }, null, 8, ["modelValue", "onChange"]),
        (_ctx.pending)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 2,
              indeterminate: ""
            }))
          : (_ctx.scanValue)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass([_ctx.getColor(), "py-1 ma-0"]),
                style: {"height":"100%"}
              }, [
                (_ctx.ticket)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.ticket.desc) + " ", 1),
                      _hoisted_15,
                      _hoisted_16,
                      (_ctx.ticket.ok)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_17, "ПЕРВОЕ СКАНИРОВАНИЕ"))
                        : (_openBlock(), _createElementBlock("h3", _hoisted_18, [
                            _hoisted_19,
                            _hoisted_20,
                            _createTextVNode(_toDisplayString(~~((Date.now() - _ctx.ticket.lastScan) * 0.001 / 60)) + " мин. назад", 1)
                          ]))
                    ]))
                  : (_openBlock(), _createElementBlock("h3", _hoisted_21, "БИЛЕТ НЕ НАЙДЕН")),
                _hoisted_22,
                _hoisted_23
              ], 2))
            : _createCommentVNode("", true),
        _hoisted_24,
        _createTextVNode(" Итого погашено билетов: " + _toDisplayString(Object.keys(this.scans).length) + " из " + _toDisplayString(Object.keys(this.tickets).length), 1)
      ]),
      _: 1
    }, 8, ["class"]), [
      [_vShow, _ctx.userData!=null && _ctx.access]
    ]),
    (_ctx.userData!=null && _ctx.access==null)
      ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Для " + _toDisplayString(_ctx.userData.email) + " нет доступа. ", 1),
                _hoisted_25,
                _hoisted_26,
                (_ctx.access==null)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      onClick: _ctx.requestAccess
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.userData!=null && _ctx.access===false)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (_ctx.userData==null)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 2,
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    _hoisted_29
  ], 64))
}